type EventName =
  | "secret_created"
  | "secret_deleted"
  | "token_generated"
  | "proxy_created"
  | "proxy_deleted"
  | "virtual_env_created"
  | "virtual_env_deleted"
  | "billing_viewed"
  | "plan_upgraded";

declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: Record<string, string | number>) => void;
    };
  }
}

export function trackEvent(
  name: EventName,
  data?: Record<string, string | number>,
) {
  window.umami?.track(name, data);
}
